import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import DistVafCircularProgress from "./common/distVafCircularProgress";
import Button from '@mui/material/Button'
import $ from 'jquery'
import { URL_API } from '../config/urls'
import fetchWithToken from 'config/UseFetchWithToken';
import {formatarIdentificacao} from './util';
import { PictureAsPdfOutlined } from '@mui/icons-material';

export default function AtualizacaoAprovar() {

    const nav = useNavigate();
    const [solicitacoes, setSolicitacoes] = useState([]);
    const [loader, setLoader]  = useState(true);

    useEffect(() => {

        setLoader(true)
        let url = `${URL_API}/api/v1/public/atualizaPrefeitura/obterSolicitacoes`

        let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

        fetchWithToken(url, requestAuthorization)
			.then(res => res.json())
			.then(res => {
			    if(res.length > 0){
                    setSolicitacoes(res);
                }
                else {
                    alert("Não possui solicitações.")
                }
                carregarTabela();
                setLoader(false);
            })
            .catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
                setLoader(false);
			});
    }, [])

    function carregarTabela(){
        $(document).ready(function () {
            setTimeout(function () {
                $('#tblDados').DataTable({
                    columnDefs: [
                        { orderable: true, targets: 2 },
                        { orderable: true, targets: 3 },
                        { orderable: true, targets: 4 }
                    ],
                    lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
                    columns: [{ width: '20%' }, null, { width: '5%' },  null, { width: '5%' }, null, null, null],
                    pageLength: 200,
                    order: [[1, 'asc']],
                    language: {
                        url: '/pt-BR.json'
                    }
                });
            }, 100);
        });
    }

    function visualizarArquivo (idSolicitacao, nomeArquivo) {

        setLoader(true)
        let url = `${URL_API}/api/v1/public/atualizaPrefeitura/visualizarArquivo/${idSolicitacao}`
        let token_keycloack = sessionStorage.getItem('token_keycloack');

        const opcoes = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json',  "Authorization": `Bearer ${token_keycloack}` }
           // , mode: 'no-cors'
		};
        fetchWithToken(url, opcoes)
        .then(res => {
            if (!res.ok) {
                setLoader(false)
                throw new Error('Erro ao baixar o arquivo');
            }
            return res.blob();
        })
        .then(blob => {
            const href = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');

            link.href = href;
            link.setAttribute('download', nomeArquivo)
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link)
            window.URL.revokeObjectURL(href);
            setLoader(false)
        })
        .catch(_err => {
            alert("Erro interno na aplicação - " + _err)
            console.error("Erro interno na aplicação - " + _err)
            setLoader(false)
        });
    }

    return (
        <div>
            <header className="main">
                <h2> Solicitações de Atualização de Prefeituras</h2>
            </header>
            <div className="row">
				<div className="col-12">
				{(loader && <DistVafCircularProgress />)}
                    <div className="col-12 align-right">
                        <Button variant="contained" className="button-secondary" onClick={ () => window.location.reload()} style={{"margin": "0 15px"}}>
                            Atualizar Página
                        </Button> 
                        
                        <Button variant="contained" className="button-secondary" onClick={ () => nav(-1) }>Voltar</Button>
                    </div>
					<div className="margem-antes"></div>
                        <table id='tblDados'className="stripe row-border">
                            <thead>
                                <tr>
                                    <th>Prefeitura </th>
                                    <th>Responsável</th>
                                    <th>Telefone</th>
                                    <th>Email</th>
                                    <th>Identificação</th>
                                    <th>Data da Solicitacao</th>
                                    <th>Situação</th>
                                    <th>Documento</th>
                                </tr>
                            </thead>
                            <tbody>
                                {solicitacoes.map((solicitacao) => (
                                    <tr key={solicitacao.codigoPrefeitura}>
                                        <td>{solicitacao.nome}</td>
                                        <td>{solicitacao.responsavel}</td>
                                        <td>{solicitacao.telefone}</td>
                                        <td>{solicitacao.email}</td>
                                        <td>{formatarIdentificacao(solicitacao.identificacao)}</td>
                                        <td>{solicitacao.dtSolicitacaoStr}</td>
                                        <td>{solicitacao.flAprovadoStr}</td>
                                        <td> 
                                            <Button variant="contained" color="primary" onClick={() => visualizarArquivo(solicitacao.sqSolicitacao, solicitacao.nmComprovante)} startIcon={<PictureAsPdfOutlined  />} style={{ width: '85%' }}>
                                                Visualizar
                                            </Button>    
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>    
        </div>
    )
}